export default __webpack_public_path__ + "static/glass-door-logo-045760bdac7e21bada3258855a60dfa4.svg";